import http from 'App/lib/http';
import { Store } from 'rc-field-form/es/interface';
import { $enum } from 'ts-enum-util';

// `true` or `false` to override all caching. `null` to disable override.
const GLOBAL_CACHE_OVERRIDE_VALUE: boolean | null = false;

// rawFetcher is for fetching data outside the /api/alliance scheme,
// but still allows us to use mockedAxios = new MockAdapter(http);
// So far only used and tested within BannerNotificationList.tsx
export const rawFetcher = (endpoint: string, cache: boolean = false) =>
  http
    .request({
      url: endpoint,
      headers: {
        'X-CACHE-RESPONSE': (GLOBAL_CACHE_OVERRIDE_VALUE ?? cache).toString(),
      },
    })
    .then((res) => res.data.data);

const fetcher = (endpoint: string, cache: boolean = false) =>
  http
    .request({
      url: `/api/alliance/${endpoint}`,
      headers: {
        'X-CACHE-RESPONSE': (GLOBAL_CACHE_OVERRIDE_VALUE ?? cache).toString(),
      },
    })
    .then((res) => res.data.data);

export const postFetcher = (
  endpoint: string,
  data: Store,
  cache: boolean = false
) =>
  http
    .request({
      method: 'POST',
      url: `/api/alliance/${endpoint}`,
      headers: {
        'X-CACHE-RESPONSE': (GLOBAL_CACHE_OVERRIDE_VALUE ?? cache).toString(),
        'Content-Type': 'application/json',
      },
      data,
    })
    .then((res) => res.data.data);

export enum AccountAction {
  LOG_IN = 'login',
  SET_ACCOUNT = 'setAccount',
  NO_ACTION = 'noAction',
}

export const getAccountAction = () => {
  const accountActionItem = localStorage.getItem('accountAction');
  const accountAction = $enum(AccountAction).asValueOrDefault(
    accountActionItem,
    AccountAction.NO_ACTION
  );
  return accountAction;
};

export const accountFetcher = (
  endpoint: string,
  data: Store,
  cache: boolean = false
) =>
  getAccountAction() === AccountAction.NO_ACTION
    ? new Promise<null>((resolve) => {
        setTimeout(() => resolve(null));
      })
    : http
        .request({
          method: 'POST',
          url: `/api/alliance/${endpoint}`,
          headers: {
            'X-CACHE-RESPONSE': (
              GLOBAL_CACHE_OVERRIDE_VALUE ?? cache
            ).toString(),
            'Content-Type': 'application/json',
          },
          data: {
            ...data,
            IsLogin: getAccountAction() === AccountAction.LOG_IN,
          },
        })
        .then((res) => {
          localStorage.setItem('accountAction', '');
          return res.data.data;
        });

export default fetcher;
